import type { SelectComponentProps } from "@quillsql/react"
import { ChangeEvent } from "react"

import { Label } from "@atoms"

import { Select } from "@molecules"
import type { SelectListItem } from "@molecules/Select/SelectListItem/SelectListItem.types"

import styles from "./QuillSelect.module.scss"

export default function QuillSelect(props: SelectComponentProps) {
    const { value, label, options, onChange, disabled } = props

    const selectOptions: SelectListItem[] = options.map((option) => ({
        label: option.label,
        value: String(option.value),
    }))

    const currentValue = value != null ? String(value) : ""
    const defaultItem = selectOptions.find((option) => option.value === currentValue) ?? null

    const handleSelect = (item: SelectListItem) => {
        const syntheticEvent = {
            target: { value: item.value },
        } as ChangeEvent<HTMLSelectElement>
        onChange(syntheticEvent)
    }

    return (
        <div className={styles.base}>
            {label && <Label label={label} variant="subtle" />}
            <Select.Root defaultSelectedItem={defaultItem}>
                <Select.Input isControlled={false} placeholder="Select" size="sm" isDisabled={disabled} />
                <Select.Viewport>
                    <Select.List title={label ?? "Select"}>
                        <Select.ListSearch />
                        <Select.ListGroup>
                            {selectOptions.map((option) => (
                                <Select.ListItem
                                    key={option.value}
                                    variant="default"
                                    item={option}
                                    onSelect={handleSelect}
                                />
                            ))}
                        </Select.ListGroup>
                    </Select.List>
                </Select.Viewport>
            </Select.Root>
        </div>
    )
}
